export class MitigationsFactory {
  constructor(instance) {
    this.instance = instance;
  }

  listMitigations(filters) {
    return this.instance.get('/v1/mitigations', {
      params: filters || null,
    });
  }
}

export default MitigationsFactory;
